import { AttributeType, AudienceFilterType } from 'types/create-campaign';

// function to change local audience format to Braze api format
export const convertAudienceToBrazeFormat = (input: AudienceFilterType[][]) => {
  if (!input || input.length === 0) {
    return {};
  }
  return {
    AND: input.map((group: AudienceFilterType[]) => {
      if (group.length === 1) {
        const { attribute, operator, value, ui_presentation } = group[0];
        return {
          custom_attribute: {
            custom_attribute_name: attribute.name,
            comparison: operator,
            value: value,
            ui_presentation: ui_presentation,
          },
        };
      } else {
        const orGroup = group.map(
          ({ attribute, operator, value, ui_presentation }: any) => ({
            custom_attribute: {
              custom_attribute_name: attribute.name,
              comparison: operator,
              value: value,
              ui_presentation: ui_presentation,
            },
          })
        );
        return { OR: orGroup };
      }
    }),
  };
};

export type AudienceBrazeFormat = ReturnType<
  typeof convertAudienceToBrazeFormat
>;

export const getAttributeDisplayName = (
  customAttribute: any,
  attributesList: AttributeType[]
) => {
  const attributeName = customAttribute.custom_attribute.custom_attribute_name;
  const foundAttribute = attributesList.find(
    (attribute) => attribute.name === attributeName
  );

  if (foundAttribute) {
    return foundAttribute.display_name !== ''
      ? foundAttribute.display_name
      : foundAttribute.name;
  } else {
    return null;
  }
};

export const getValueDisplayName = (
  customAttribute: any,
  attributesList: AttributeType[]
) => {
  const attributeName = customAttribute.custom_attribute.custom_attribute_name;
  const foundAttribute = attributesList.find(
    (attribute) => attribute.name === attributeName
  );

  if (foundAttribute) {
    return foundAttribute.display_name !== ''
      ? foundAttribute.display_name
      : foundAttribute.name;
  } else {
    return null;
  }
};
